import { combineReducers } from 'redux';
import routing from './routing';
import basicDetails from './basicDetails'
import uploadDocuments from './uploadDocuments'
import incidentDetails from './incidentDetails';
import referenceData from './referenceData';

export const allsureHomeClaim = combineReducers({
    basicDetails,
    routing,
    uploadDocuments,
    incidentDetails,
    referenceData
});
